"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagApi = exports.TagApiFactory = exports.TagApiFp = exports.TagApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * TagApi - axios parameter creator
 * @export
 */
const TagApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gel all tag values present in scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetAllTagValues: (schemeId_1, ...args_1) => __awaiter(this, [schemeId_1, ...args_1], void 0, function* (schemeId, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagEndpointGetAllTagValues', 'schemeId', schemeId);
            const localVarPath = `/tags/allTagValues/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get tag ids present in a scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetAllTags: (schemeId_2, ...args_2) => __awaiter(this, [schemeId_2, ...args_2], void 0, function* (schemeId, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagEndpointGetAllTags', 'schemeId', schemeId);
            const localVarPath = `/tags/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a map of lists of compatible tags for eatch requested type
         * @param {string} schemeId
         * @param {Array<string>} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetCompatibleTags: (schemeId_3, type_1, ...args_3) => __awaiter(this, [schemeId_3, type_1, ...args_3], void 0, function* (schemeId, type, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagEndpointGetCompatibleTags', 'schemeId', schemeId);
            const localVarPath = `/tags/compatibleTags/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get list of tag trees defined for the scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetDefinedTagTree: (schemeId_4, ...args_4) => __awaiter(this, [schemeId_4, ...args_4], void 0, function* (schemeId, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagEndpointGetDefinedTagTree', 'schemeId', schemeId);
            const localVarPath = `/tags/tagTrees/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return a list of tag values that would return non-empty results if used as filter allong with given filterValues. If tagId is null, return values for all tags.
         * @param {string} schemeId
         * @param {RelevantTagValueRequestData} [relevantTagValueRequestData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetRelevantTags: (schemeId_5, relevantTagValueRequestData_1, ...args_5) => __awaiter(this, [schemeId_5, relevantTagValueRequestData_1, ...args_5], void 0, function* (schemeId, relevantTagValueRequestData, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagEndpointGetRelevantTags', 'schemeId', schemeId);
            const localVarPath = `/tags/relevantTags/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(relevantTagValueRequestData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get info of specified tags
         * @param {string} schemeId
         * @param {Array<string>} [tagId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetTagInfo: (schemeId_6, tagId_1, ...args_6) => __awaiter(this, [schemeId_6, tagId_1, ...args_6], void 0, function* (schemeId, tagId, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagEndpointGetTagInfo', 'schemeId', schemeId);
            const localVarPath = `/tags/tagInfo/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tagId) {
                localVarQueryParameter['tagId'] = tagId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TagApiAxiosParamCreator = TagApiAxiosParamCreator;
/**
 * TagApi - functional programming interface
 * @export
 */
const TagApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TagApiAxiosParamCreator)(configuration);
    return {
        /**
         * Gel all tag values present in scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetAllTagValues(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagEndpointGetAllTagValues(schemeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TagApi.tagEndpointGetAllTagValues']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get tag ids present in a scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetAllTags(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagEndpointGetAllTags(schemeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TagApi.tagEndpointGetAllTags']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get a map of lists of compatible tags for eatch requested type
         * @param {string} schemeId
         * @param {Array<string>} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetCompatibleTags(schemeId, type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagEndpointGetCompatibleTags(schemeId, type, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TagApi.tagEndpointGetCompatibleTags']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get list of tag trees defined for the scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetDefinedTagTree(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagEndpointGetDefinedTagTree(schemeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TagApi.tagEndpointGetDefinedTagTree']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return a list of tag values that would return non-empty results if used as filter allong with given filterValues. If tagId is null, return values for all tags.
         * @param {string} schemeId
         * @param {RelevantTagValueRequestData} [relevantTagValueRequestData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetRelevantTags(schemeId, relevantTagValueRequestData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagEndpointGetRelevantTags(schemeId, relevantTagValueRequestData, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TagApi.tagEndpointGetRelevantTags']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get info of specified tags
         * @param {string} schemeId
         * @param {Array<string>} [tagId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetTagInfo(schemeId, tagId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagEndpointGetTagInfo(schemeId, tagId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TagApi.tagEndpointGetTagInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.TagApiFp = TagApiFp;
/**
 * TagApi - factory interface
 * @export
 */
const TagApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TagApiFp)(configuration);
    return {
        /**
         * Gel all tag values present in scheme
         * @param {TagApiTagEndpointGetAllTagValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetAllTagValues(requestParameters, options) {
            return localVarFp.tagEndpointGetAllTagValues(requestParameters.schemeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get tag ids present in a scheme
         * @param {TagApiTagEndpointGetAllTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetAllTags(requestParameters, options) {
            return localVarFp.tagEndpointGetAllTags(requestParameters.schemeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a map of lists of compatible tags for eatch requested type
         * @param {TagApiTagEndpointGetCompatibleTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetCompatibleTags(requestParameters, options) {
            return localVarFp.tagEndpointGetCompatibleTags(requestParameters.schemeId, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of tag trees defined for the scheme
         * @param {TagApiTagEndpointGetDefinedTagTreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetDefinedTagTree(requestParameters, options) {
            return localVarFp.tagEndpointGetDefinedTagTree(requestParameters.schemeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return a list of tag values that would return non-empty results if used as filter allong with given filterValues. If tagId is null, return values for all tags.
         * @param {TagApiTagEndpointGetRelevantTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetRelevantTags(requestParameters, options) {
            return localVarFp.tagEndpointGetRelevantTags(requestParameters.schemeId, requestParameters.relevantTagValueRequestData, options).then((request) => request(axios, basePath));
        },
        /**
         * Get info of specified tags
         * @param {TagApiTagEndpointGetTagInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagEndpointGetTagInfo(requestParameters, options) {
            return localVarFp.tagEndpointGetTagInfo(requestParameters.schemeId, requestParameters.tagId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TagApiFactory = TagApiFactory;
/**
 * TagApi - object-oriented interface
 * @export
 * @class TagApi
 * @extends {BaseAPI}
 */
class TagApi extends base_1.BaseAPI {
    /**
     * Gel all tag values present in scheme
     * @param {TagApiTagEndpointGetAllTagValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagEndpointGetAllTagValues(requestParameters, options) {
        return (0, exports.TagApiFp)(this.configuration).tagEndpointGetAllTagValues(requestParameters.schemeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get tag ids present in a scheme
     * @param {TagApiTagEndpointGetAllTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagEndpointGetAllTags(requestParameters, options) {
        return (0, exports.TagApiFp)(this.configuration).tagEndpointGetAllTags(requestParameters.schemeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a map of lists of compatible tags for eatch requested type
     * @param {TagApiTagEndpointGetCompatibleTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagEndpointGetCompatibleTags(requestParameters, options) {
        return (0, exports.TagApiFp)(this.configuration).tagEndpointGetCompatibleTags(requestParameters.schemeId, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get list of tag trees defined for the scheme
     * @param {TagApiTagEndpointGetDefinedTagTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagEndpointGetDefinedTagTree(requestParameters, options) {
        return (0, exports.TagApiFp)(this.configuration).tagEndpointGetDefinedTagTree(requestParameters.schemeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return a list of tag values that would return non-empty results if used as filter allong with given filterValues. If tagId is null, return values for all tags.
     * @param {TagApiTagEndpointGetRelevantTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagEndpointGetRelevantTags(requestParameters, options) {
        return (0, exports.TagApiFp)(this.configuration).tagEndpointGetRelevantTags(requestParameters.schemeId, requestParameters.relevantTagValueRequestData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get info of specified tags
     * @param {TagApiTagEndpointGetTagInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagEndpointGetTagInfo(requestParameters, options) {
        return (0, exports.TagApiFp)(this.configuration).tagEndpointGetTagInfo(requestParameters.schemeId, requestParameters.tagId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TagApi = TagApi;
//# sourceMappingURL=tag-api.js.map